const action = {
  CONFIGMGMNT_DIV_READ: 'CONFIGMGMNT_DIV_READ',
  CONFIGMGMNT_LANG_READ: 'CONFIGMGMNT_LANG_READ',
  CONFIGMGMNT_SHARE_READ: 'CONFIGMGMNT_SHARE_READ',
  CONFIGMGMNT_INVESTOR_READ: 'CONFIGMGMNT_INVESTOR_READ',
  CONFIGMGMNT_NUDGE_READ: 'CONFIGMGMNT_NUDGE_READ',
  CONFIG_READ_SUCCESS: 'CONFIG_READ_SUCCESS',
  CONFIG_ADD_NEW: 'CONFIG_ADD_NEW',
  CONFIG_UPDATE: 'CONFIG_UPDATE',
  CONFIGMGMNT_TAX_READ: 'CONFIGMGMNT_TAX_READ',
  CONFIG_ADD_NUDGING: 'CONFIG_ADD_NUDGING',
  NUDGING_FETCH_ID: 'NUDGING_FETCH_ID',
  NUDGE_FETCH_LIST_ID: 'NUDGE_FETCH_LIST_ID',
  CONFIGMGMNT_AGM_READ: 'CONFIGMGMNT_AGM_READ',
  CONFIGMGMNT_BOND_READ: 'CONFIGMGMNT_BOND_READ',

  configAddNew:(history, dataObj, callback) => ({ //Action creator function
    type: action.CONFIG_ADD_NEW, //Action
    payload: { history, dataObj, callback } //pass payload to action, we should pass as little data to action
  }),
  configAddNudging: (history, dataObj, callback) => ({ //Action creator function
    type: action.CONFIG_ADD_NUDGING, //Action
    payload: { history, dataObj, callback } //pass payload to action, we should pass as little data to action
  }),
  configDividendRead:(page) => ({ //Action creator function
    type: action.CONFIGMGMNT_DIV_READ, //Action
    payload: { page } //pass payload to action, we should pass as little data to action
  }),
  configLangRead:(readFilter, page) => ({ //Action creator function
    type: action.CONFIGMGMNT_LANG_READ, //Action
    payload: {readFilter, page } //pass payload to action, we should pass as little data to action
  }),
  configShareRead:(readFilter, page) => ({ //Action creator function
    type: action.CONFIGMGMNT_SHARE_READ, //Action
    payload: {readFilter, page } //pass payload to action, we should pass as little data to action
  }),
  configTaxRead:(readFilter, page) => ({ //Action creator function
    type: action.CONFIGMGMNT_TAX_READ, //Action
    payload: {readFilter, page } //pass payload to action, we should pass as little data to action
  }),
  configInvestorRead:(readFilter, page) => ({ //Action creator function
    type: action.CONFIGMGMNT_INVESTOR_READ, //Action
    payload: {readFilter, page } //pass payload to action, we should pass as little data to action
  }),
  configNudgingdRead: (page) => ({ //Action creator function
    type: action.CONFIGMGMNT_NUDGE_READ, //Action
    payload: { page } //pass payload to action, we should pass as little data to action
  }),
  nudgeFetchById: (id) => ({
    type: action.NUDGING_FETCH_ID,
    payload: { id }
  }),
  nudgeListById: (data, message, success) => ({
    type: action.NUDGE_FETCH_LIST_ID,
    data,
    message,
    success
  }),
  configUpdate: (history, configPojo) => ({
    type: action.CONFIG_UPDATE,
    payload: { history, configPojo }
  }),
  onPageChange: (info, page) => ({
    type: action.CONFIGMGMNT_DIV_READ,
    payload: { info, page }
  }),
  onPageChange: (info, page) => ({
    type: action.CONFIGMGMNT_LANG_READ,
    payload: { info, page }
  }),
  onPageChange: (info, page) => ({
    type: action.CONFIGMGMNT_SHARE_READ,
    payload: { info, page }
  }),
  onPageChange: (info, page) => ({
    type: action.CONFIGMGMNT_INVESTOR_READ,
    payload: { info, page }
  }),
  configReadSearchSuccess: (data, success, totalCount, page) => ({
    type: action.CONFIG_READ_SUCCESS,
    data,
    success,
    totalCount,
    page,
  }),
  configAgmRead: (page) => ({ //Action creator function
    type: action.CONFIGMGMNT_AGM_READ, //Action
    payload: { page } //pass payload to action, we should pass as little data to action
  }),
  configBondRead: (page) => ({ //Action creator function
    type: action.CONFIGMGMNT_BOND_READ, //Action
    payload: { page } //pass payload to action, we should pass as little data to action
  }),
  

};
export default action;
  